import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import type { Language } from "../i8n/registry";
import { SelectItem } from "../components/ui/FormSelect";

interface LanguageContextType {
    language: Language;
    availableLanguages: SelectItem[];
    handleLanguageChange: (lang: string) => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

const LANGUAGE_STORAGE_KEY = "selectedLanguage";

export function LanguageProvider({ children }: { children: ReactNode }) {
    const [language, setLanguage] = useState<Language>(() => {
        return (localStorage.getItem(LANGUAGE_STORAGE_KEY) as Language) ?? "de";
    });

    useEffect(() => {
        localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    }, [language]);

    const availableLanguages: SelectItem[] = [
        { name: "🇩🇪 DE", value: "de" },
        { name: "🇬🇧 EN", value: "en" },
    ];

    const handleLanguageChange = (newLanguage: string) => {
        setLanguage(newLanguage as Language);
    };

    return (
        <LanguageContext.Provider
            value={{ language, availableLanguages, handleLanguageChange }}
        >
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error("useLanguage must be used within a LanguageProvider");
    }
    return context;
}
